import React from 'react';

import type { SelectPropTypes } from '../Form/Select';
import { Select } from '../Form/Select';
import type { UseGraphFieldArgument } from './useGraphField';
import { useGraphField } from './useGraphField';

export type SelectFieldPropTypes = UseGraphFieldArgument<SelectPropTypes['value']> &
  Omit<SelectPropTypes, 'value'>;

export const SelectField: React.FC<SelectFieldPropTypes> = ({
  config,
  validate,
  required,
  subscription,
  ...props
}) => {
  const { computedError, input } = useGraphField<SelectPropTypes['value'], HTMLElement>({
    name: props.name,
    config,
    validate,
    required,
    subscription,
  });
  return <Select {...props} {...input} error={computedError} />;
};
